import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutationCourseGARShare } from 'gql/mutations/course';
import { useQueryMe } from 'gql/queries/me';

import GAR from './GAR';

const GARContainer = ({ course, handleModalClose, ...props }) => {
  const { t } = useTranslation();
  const { isLoading, data } = useQueryMe();
  const { garDIV, garGRO, initialValues } = useMemo(() => {
    const meDIV = isLoading ? [] : data.me.metadata.garDIV || [];
    const meGRO = isLoading ? [] : data.me.metadata.garGRO || [];
    const courseDIV = course.gar?.div || [];
    const courseGRO = course.gar?.gro || [];
    const divs = Object.fromEntries([
      ...meDIV.map((div) => [div, courseDIV.includes(div)]),
      ...courseDIV.map((div) => [div, true]),
    ]);
    const gros = Object.fromEntries([
      ...meGRO.map((gro) => [gro, courseGRO.includes(gro)]),
      ...courseGRO.map((gro) => [gro, true]),
    ]);
    return {
      garDIV: Object.keys(divs).sort((a, b) => a.localeCompare(b)),
      garGRO: Object.keys(gros).sort((a, b) => a.localeCompare(b)),
      initialValues: {
        div: divs,
        gro: gros,
      },
    };
  }, [isLoading, data, course]);
  const mutationCourseGARShare = useMutationCourseGARShare();
  const handleSave = useCallback(
    async ({ div, gro }) => {
      try {
        const d = Object.entries(div)
          .filter(([, v]) => v)
          .map(([key]) => key);
        const g = Object.entries(gro)
          .filter(([, v]) => v)
          .map(([key]) => key);
        await mutationCourseGARShare({
          courseId: course.id,
          div: d,
          gro: g,
        });
        handleModalClose();
      } catch (err) {
        //
      }
    },
    [course, handleModalClose, mutationCourseGARShare],
  );
  return (
    <GAR
      garDIV={garDIV}
      garGRO={garGRO}
      handleSave={handleSave}
      initialValues={initialValues}
      t={t}
      {...props}
    />
  );
};

GARContainer.propTypes = {
  course: PropTypes.object.isRequired,
  handleModalClose: PropTypes.func.isRequired,
};

export default GARContainer;
